/**
 * export ZipArchive class
 */
export * from './zip-archive';
export * from './compression-writer';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-compression/src/index.js
// module id = 1961
// module chunks = 0